import ProductInfo from "./ProductInfo";
import productImage from "../../../assets/images/Products/hd-ft.png";

function HelpDesk() {
  return (
    <>
      <ProductInfo
        title="HelpDesk Portal"
        primaryDescription="HelpDesk Portal is a SharePoint/MS Teams app"
        secondaryDescription="where you can create/track your support tickets/tasks"
        features={[
          "Support for SharePoint Webpart, Full-Page webpart components",
          "Support for Teams Tab",
          "Timeline view for tickets",
          "Comments feature on tickets",
          "Customizable Statuses, priorities, categories and subcategories of tickets",
          "Email notifications on ticket updates",
          "Customizable email templates",
          "Upload supporting documents associated with the tickets",
          "Advance search feature for tickets",
          "Report charts based on ticket statuses, priorities and categories",
          "Easy access to the recent tickets from the home page",
          "Export tickets as excel files",
          "Write your own custom style",
        ]}
        image={productImage}
        appsourceLink="https://appsource.microsoft.com/en-us/product/office/WA200007414?tab=Overview"
        youTubeLink="https://www.youtube.com/embed/-eejnQn42FU"
        pricings={[
          {
            userLimit: "Unlimited",
            // strikedPrice: "$99.99",
            price: "$99.99 USD",
            priceText: "/Month",
            // offerText: "Offer valid till 04 Jul 2025",
            secondaryText: "Billed Annually",
            paymentLink: "https://buy.stripe.com/28E3cx36k7DBeG21sj9Ve0o",
          },
        ]}
      />
    </>
  );
}

export default HelpDesk;
